<template>
  <index-loader></index-loader>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div v-if="loading">
        <p>Loading...</p>
      </div>
      <div class="row" v-else>
        <div class="col-md-12">
          <!-- <dashboard-header :title="title" /> -->
          <!-- 🔹 KPI SUMMARY CARDS -->
          <div class="row mb-4">
            <!-- Total Leads -->
            <div class="col-md-3 col-sm-6 d-flex">
              <div class="card kpi-card w-100">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="kpi-title">Total Leads</p>
                      <h3 class="kpi-value">
                        {{ DashboardSummary.TotalLeads }}
                      </h3>
                    </div>
                    <div class="kpi-icon bg-primary">
                      <i class="ti ti-users"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Leads Won -->
            <div class="col-md-3 col-sm-6 d-flex">
              <div class="card kpi-card w-100">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="kpi-title">Total Leads Won</p>
                      <h3 class="kpi-value text-success">
                        {{ DashboardSummary.TotalLeadsWon }}
                      </h3>
                    </div>
                    <div class="kpi-icon bg-success">
                      <i class="ti ti-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Top Employee -->
            <div class="col-md-3 col-sm-6 d-flex">
              <div class="card kpi-card w-100">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="kpi-title">Top Performing Employee</p>
                      <h6 class="mb-1">
                        {{ DashboardSummary.TopPerformingEmployee }}
                      </h6>
                      <small class="text-muted"
                        >Won Leads: <b>{{ DashboardSummary.LeadWon }}</b></small
                      >
                    </div>
                    <div class="kpi-icon bg-info">
                      <i class="ti ti-user-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Top Exhibition -->
            <div class="col-md-3 col-sm-6 d-flex">
              <div class="card kpi-card w-100">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <p class="kpi-title">Top Exhibition</p>
                      <h6 class="mb-1">
                        {{ DashboardSummary.ExhibitionName }}
                      </h6>
                      <small class="text-muted"
                        >Leads:
                        <b>{{ DashboardSummary.ExhibitionLeadCount }}</b></small
                      >
                    </div>
                    <div class="kpi-icon bg-warning">
                      <i class="ti ti-building-store"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4>
                      <i class="ti ti-grip-vertical me-1"></i>Priority Wise
                      Leads
                    </h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="leadpiechartLeads">
                    <apexchart
                      type="pie"
                      height="450"
                      :options="leadPriorityPieChart.pieCharts"
                      :series="leadPriorityPieChart.series"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4>
                      <i class="ti ti-grip-vertical me-1"></i>Exhibition Wise
                      Leads
                    </h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="contacts-analysis-leads">
                    <apexchart
                      type="bar"
                      height="450"
                      :options="ExibhitionWiseCharts.chartOptions"
                      :series="ExibhitionWiseCharts.series"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4>
                      <i class="ti ti-grip-vertical me-1"></i>Lead Status Funnel
                    </h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="project-stage">
                    <apexchart
                      type="bar"
                      height="450"
                      :options="projectStaCharts.stagesCharts"
                      :series="projectStaCharts.series"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4>
                      <i class="ti ti-grip-vertical me-1"></i>Monthly Leads
                    </h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="contact-report">
                    <apexchart
                      type="bar"
                      height="500"
                      :options="contactReportChart.reportCharts"
                      :series="contactReportChart.series"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4>
                      <i class="ti ti-grip-vertical me-1"></i>Employee Wise
                      Leads
                    </h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="contact-report1">
                    <apexchart
                      type="bar"
                      height="450"
                      :options="employeeWiseChart.chartOptions"
                      :series="employeeWiseChart.series"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex">
              <div class="card w-100">
                <div class="card-header border-0 pb-0">
                  <div
                    class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                  >
                    <h4><i class="ti ti-grip-vertical me-1"></i> Leads</h4>
                  </div>
                </div>
                <div class="card-body">
                  <div id="contact-report2">
                    <apexchart
                      type="line"
                      height="450"
                      :options="multiLineChart.chartOptions"
                      :series="multiLineChart.series"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <project-dashboard-modal></project-dashboard-modal>
</template>
<script>
import http from "@/utils/http";

export default {
  data() {
    return {
      title: "Leads Dashboard",
      DashboardSummary: {
        TotalLeads: 0,
        TotalLeadsWon: 0,
        ExhibitionName: "",
        ExhibitionLeadCount: 0,
        TopPerformingEmployee: "",
        LeadWon: 0,
      },
      leadPriorityPieChart: {
        series: [44, 55, 13, 43],
        pieCharts: {
          chart: {
            width: 450,
            type: "pie",
          },
          labels: [
            "Inpipeline",
            "Follow Up",
            "Schedule Service",
            "Conversation",
          ],
          colors: [
            "#28a745", // Very Good → Green
            "#6fcf97", // Good → Light Green
            "#dc3545", // Very Low → Danger
            "#ffc107",
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 275,
                },
                legend: {
                  position: "right",
                },
              },
            },
          ],
        },
      },

      ExibhitionWiseCharts: {
        series: [
          {
            name: "Leads",
            data: [],
          },
        ],

        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
          },

          plotOptions: {
            bar: {
              horizontal: true, // ⭐ Horizontal bar
              barHeight: "70%",
              borderRadius: 0,
            },
          },

          colors: ["#FF9F43"],

          dataLabels: {
            enabled: true,
            style: {
              colors: ["#000"],
            },
          },

          // 👇 EMPLOYEE NAMES GO HERE
          xaxis: {
            categories: [],
            title: {
              text: "",
            },
          },

          // 👇 Numeric axis (auto)
          yaxis: {
            title: {
              text: "",
            },
          },

          grid: {
            strokeDashArray: 4,
          },
        },
      },

      funnelRealValues: [],

      projectStaCharts: {
        series: [
          {
            name: "Leads",
            data: [], // 👈 STATIC display values
          },
        ],

        stagesCharts: {
          chart: {
            type: "bar",
            height: 420,
            toolbar: { show: false },
          },

          plotOptions: {
            bar: {
              horizontal: true,
              distributed: true,
              barHeight: "25%", // ⭐ good funnel size
              isFunnel: true,
            },
          },

          colors: [
            "#4A00E5",
            "#1ECBE2",
            "#FF9D0A",
            "#00918E",
            "#5CB85C",
            "#FC0027",
          ],

          dataLabels: {
            enabled: true,
            formatter: (val, opts) => {
              const index = opts.dataPointIndex;
              const label = opts.w.globals.labels[index];
              const realValue = this.funnelRealValues[index];
              return `${label}: ${realValue}`;
            },
            textAnchor: "middle",
            style: {
              fontSize: "12px",
              fontWeight: 500,
              colors: ["#000"],
            },
          },

          tooltip: {
            y: {
              formatter: (val, opts) => {
                const index = opts.dataPointIndex;
                return this.funnelRealValues[index];
              },
            },
          },

          xaxis: {
            categories: [], // 🔹 dynamic labels
          },

          legend: {
            show: false,
          },
        },
      },

      contactReportChart: {
        series: [
          {
            name: "Leads",
            data: [],
          },
        ],

        reportCharts: {
          chart: {
            height: 273,
            type: "bar", // ✅ BAR CHART
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },

          plotOptions: {
            bar: {
              columnWidth: "45%", // control bar width
              borderRadius: 4, // smooth edges
              distributed: false,
            },
          },

          colors: ["#4A00E5"],

          dataLabels: {
            enabled: false,
          },

          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },

          yaxis: {
            min: 10,
            max: 300,
            tickAmount: 5,
          },

          grid: {
            strokeDashArray: 4,
          },

          legend: {
            show: false,
          },
        },
      },

      employeeWiseChart: {
        series: [
          {
            name: "Leads",
            data: [120, 95, 80, 70, 60, 45],
          },
        ],

        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
          },

          plotOptions: {
            bar: {
              horizontal: true, // ⭐ Horizontal bar
              barHeight: "70%",
              borderRadius: 0,
            },
          },

          colors: ["#26CECC"],

          dataLabels: {
            enabled: true,
            style: {
              colors: ["#000"],
            },
          },

          // 👇 EMPLOYEE NAMES GO HERE
          xaxis: {
            categories: ["Rakib", "Hasan", "Sajid", "Imran", "Nayeem", "Shuvo"],
            title: {
              text: "",
            },
          },

          // 👇 Numeric axis (auto)
          yaxis: {
            title: {
              text: "",
            },
          },

          grid: {
            strokeDashArray: 4,
          },
        },
      },
      multiLineChart: {
        series: [
          {
            name: "Leads",
            data: [40, 30, 20, 30, 22, 20, 30, 20, 22, 30, 15, 20],
          },
          {
            name: "Closed",
            data: [20, 18, 15, 20, 14, 12, 18, 15, 16, 22, 10, 14],
          },
          {
            name: "Lost",
            data: [10, 12, 8, 10, 9, 8, 12, 10, 11, 13, 7, 9],
          },
        ],

        chartOptions: {
          chart: {
            type: "line",
            height: 320,
            toolbar: { show: false },
          },

          stroke: {
            width: 3,
            curve: "smooth", // ⭐ smooth lines
          },

          markers: {
            size: 4,
          },

          colors: ["#4A00E5", "#28C76F", "#EA5455"],

          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },

          yaxis: {
            title: {
              text: "Count",
            },
          },

          legend: {
            position: "top",
            horizontalAlign: "left",
          },

          grid: {
            strokeDashArray: 4,
          },

          tooltip: {
            shared: true,
            intersect: false,
          },
        },
      },
      // contactAnalysisCharts: contactAnalysisCharts,
      // multiLineChart: multiLineChart,
      loading: true,
    };
  },
  mounted() {
    this.loadLeadDashboardChartData();
  },
  methods: {
    async loadLeadDashboardChartData() {
      this.loading = true;
      const endpoint = `/leads-dashboard-chart-data`;

      try {
        const response = await http.get(endpoint);

        (this.DashboardSummary = {
          TotalLeads: response.data.DashboardSummary?.TotalLeads,
          TotalLeadsWon: response.data.DashboardSummary?.TotalLeadsWon,
          ExhibitionName: response.data.DashboardSummary?.ExhibitionName,
          ExhibitionLeadCount:
            response.data.DashboardSummary?.ExhibitionLeadCount,
          TopPerformingEmployee:
            response.data.DashboardSummary?.TopPerformingEmployee,
          LeadWon: response.data.DashboardSummary?.LeadWon,
        }),
          // Priority Wise Pie Chart
          (this.leadPriorityPieChart.series =
            response.data.priorityWiseChart.series.map(Number));

        this.leadPriorityPieChart.pieCharts.labels =
          response.data.priorityWiseChart.labels;

        //ExibhitionWiseCharts
        this.ExibhitionWiseCharts.chartOptions.xaxis.categories =
          response.data.exhibitionWiseChart.labels;

        this.ExibhitionWiseCharts.series = [
          {
            name: "Leads",
            data: response.data.exhibitionWiseChart.series.map(Number),
          },
        ];

        this.ExibhitionWiseCharts.chartOptions.chart.height =
          response.data.exhibitionWiseChart.labels.length * 35;

        // ✅ Funnel Chart (STATIC WIDTH + DYNAMIC VALUES)

        const labels = response.data.leadStageWiseChart.labels;
        const realValues = response.data.leadStageWiseChart.series;

        // store real values
        this.funnelRealValues = realValues;

        // generate static funnel width (visual only)
        const staticValues = labels.map((_, index) => {
          return (labels.length - index) * 100; // 900,800,700...
        });

        // apply to chart
        this.projectStaCharts.stagesCharts.xaxis.categories = labels;

        this.projectStaCharts.series = [
          {
            name: "Leads",
            data: staticValues, // 🔥 STATIC values for perfect funnel shape
          },
        ];

        //MOnthly
        // 📊 Monthly Leads Chart
        this.contactReportChart.reportCharts.xaxis.categories =
          response.data.monthlyLeadsChart.labels;

        this.contactReportChart.series = [
          {
            name: "Leads",
            data: response.data.monthlyLeadsChart.series,
          },
        ];

        // ✅ employee wise
        // (this.employeeWiseChart.chartOptions.xaxis.categories =
        //   response.data.EmployeeWiseChart.labels),
        //   // ✅ Update series data
        //   (this.employeeWiseChart.series = [
        //     {
        //       name: "Leads",
        //       data: response.data.EmployeeWiseChart.series,
        //     },
        //   ]);

        // Employee Wise Chart (Horizontal)
        // Employee Wise Chart
        this.employeeWiseChart.chartOptions.xaxis.categories =
          response.data.EmployeeWiseChart.labels;

        this.employeeWiseChart.series = [
          {
            name: "Leads",
            data: response.data.EmployeeWiseChart.series,
          },
        ];

        this.employeeWiseChart.chartOptions.chart.height =
          response.data.EmployeeWiseChart.labels.length * 35;

        // ✅ Multi Line Monthly Chart
        this.multiLineChart.chartOptions.xaxis.categories =
          response.data.multiLineMonthlyChart.labels;

        this.multiLineChart.series = response.data.multiLineMonthlyChart.series;

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = true;
      }
    },
  },
};
</script>
